import { Button, Form, Input, message } from 'antd';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../app/hooks';
import { selectUser } from '../../../../auth/states/userSlice';
import { setModal } from '../../../../common/slices/commonSlice';
import { useCreateAgencyMutation } from '../endpoints/agencyEndpoints';
import { IAgencyFormData } from '../types/AgenciesTypes';
import LoadingIndicator from '../../../../components/common/spinner/LoadingIndicator';

const AddNewAgency = ({ agencyNameList }: { agencyNameList: string[] }) => {
  const dispatch = useAppDispatch();
  const user = useSelector(selectUser);
  const [form] = Form.useForm();
  const [addAgency, { isError, isSuccess, isLoading }] =
    useCreateAgencyMutation();
  useEffect(() => {
    if (isSuccess) {
      message.success('Agency Added Successfully');
    } else if (isError) {
      message.error('Something went wrong');
    }
  }, [isSuccess, isError]);
  const handleSubmit = async (values: IAgencyFormData) => {
    const body: IAgencyFormData = {
      ...values,
      agency_created_by: user?.user_id as number,
    };
    await addAgency(body);
    dispatch(setModal(false));
    form.resetFields();
  };
  return (
    <Form
      layout='horizontal'
      form={form}
      labelAlign='left'
      labelCol={{ span: 9 }}
      wrapperCol={{ span: 16 }}
      onFinish={handleSubmit}
    >
      <Form.Item
        label='Agency Name'
        name='agency_name'
        rules={[
          { required: true, message: 'Please enter agency name!' },
          { max: 75, message: 'Maximum 75 characters' },
          { whitespace: true },
          {
            validator(_, value) {
              if (value) {
                if (agencyNameList.includes(value.trim())) {
                  return Promise.reject('Agency Name is already Exist');
                } else {
                  return Promise.resolve();
                }
              } else {
                return Promise.resolve();
              }
            },
          },
        ]}
      >
        <Input placeholder='Enter Agency Name' />
      </Form.Item>

      <Form.Item wrapperCol={{ offset: 9, span: 16 }}>
        <Button
          type='primary'
          htmlType='submit'
          loading={isLoading}
        >
          Submit
        </Button>
      </Form.Item>

      {isLoading && <LoadingIndicator />}
    </Form>
  );
};

export default AddNewAgency;
